import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ButtonGradient from "components/elements/button_gradient";
import ButtonChoiceResume from "components/elements/button_choice_resume";
import ResumeATS from "assets/icons/resume_ats.svg";
import ResumeModern from "assets/icons/resume_modern.svg";
import { useSelector } from "react-redux";
import { ResumeType } from "utils/other/enums";
import { Link } from "react-router-dom";
import { Fragment, forwardRef, useEffect, useRef, useState } from "react";
import { firebaseDatabase } from "config/firebase";
import { collection, onSnapshot, query, where } from "firebase/firestore";

const Transition = forwardRef((props, ref) => 
  <Slide {...props} ref={ref} direction="down" timeout={500} />
);

export default function DialogDownloadResume({ open, handleClose }) {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const resume = useSelector((state) => state.resumeReducer);
  const downloadRef = useRef();
  const [resumeFiles, setResumeFiles] = useState([]);

  const getResumeFileUrl = () =>
    resumeFiles.find((_) =>
      _.name.toLowerCase().includes(resume.type?.toLowerCase())
    )?.url;

  useEffect(() => {
    const listenerResumeFiles = onSnapshot(
      query(
        collection(firebaseDatabase, "files"),
        where("name", "in", ["Curriculum Vitae ATS", "Curriculum Vitae Modern"])
      ),
      (_) => setResumeFiles(_.docs.map((_) => ({ id: _.id, ..._.data() })))
    );

    return () => listenerResumeFiles();
  }, []);

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{ sx: { borderRadius: "30px" } }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 5,
            }}
          >
            {matchUpMd ? <Box sx={{ width: 20 }} /> : <Fragment></Fragment>}
            <Typography
              variant="h4"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: 16,
                textAlign: { xs: "left", md: "center" },
              }}
            >
              Pilih Jenis CV
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseRoundedIcon sx={{ width: 20 }} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ marginTop: "-10px", marginBottom: "-30px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
              padding: "20px 0",
            }}
          >
            <ButtonChoiceResume
              icon={ResumeATS}
              text="ATS Model"
              type={ResumeType.ATS}
            />
            <ButtonChoiceResume
              icon={ResumeModern}
              text="Modern Model"
              type={ResumeType.Modern}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "20px 20px 20px" }}>
          <ButtonGradient
            fullwidth
            disabled={resume.type === null || !getResumeFileUrl()}
            text={"Unduh Curriculum Vitae"}
            borderRadius="14px"
            onClick={() => {
              downloadRef.current?.click();
              handleClose();
            }}
          />
        </DialogActions>
      </Dialog>
      <Link hidden download ref={downloadRef} to={getResumeFileUrl()} />
    </Fragment>
  );
}
